
import { supabase } from '@/integrations/supabase/client';
import { Component } from '@/utils/types/componentTypes';

export async function searchComponents(
  searchTerm: string,
  subscriptionId?: string
): Promise<Component[]> {
  let query = supabase
    .from('components')
    .select(`
      *,
      component_types (
        id,
        name,
        icon,
        group_name
      ),
      organizations (
        id,
        name,
        subscription_id
      )
    `)
    .ilike('name', `%${searchTerm}%`)
    .limit(10);

  const { data, error } = await query.order('name', { ascending: true });

  if (error) {
    console.error('Error searching components:', error);
    throw error;
  }

  // Filtrar apenas componentes da subscription atual
  const filteredData = subscriptionId 
    ? (data || []).filter(component => 
        (component as any).organizations?.subscription_id === subscriptionId
      )
    : (data || []);

  return filteredData;
}
